import * as actionTypes from './actionTypes';
import { photoVignetteService } from './services';
import { actionsModalError } from '@app/src/common/modalError';

const postPhotoVignetteRequest = () => ({
  type: actionTypes.POST_PHOTO_VIGNETTE_REQUEST
});

const setPhotoVignetteFilename = (channelId: number, fileName: string) => ({
  type: actionTypes.SET_PHOTO_VIGNETTE_FILENAME,
  id: channelId,
  name: fileName
});

const postPhotoVignetteFailure = () => ({
  type: actionTypes.POST_PHOTO_VIGNETTE_FAILURE
});

export const setPhotoVignetteAll = (data) => ({
  type: actionTypes.SET_PHOTO_VIGNETTE_ALL,
  data
})

export const setPhotoVignetteData = (channelId: number, data: any) => ({
  type: actionTypes.SET_PHOTO_VIGNETTE_DATA,
  id: channelId,
  data
});

export const clearPhotoVignette = (channelId: number) => ({
  type: actionTypes.CLEAR_PHOTO_VIGNETTE,
  id: channelId
});

export const postPhotoVignette = (categoryId: number, channelId: number, json): Function => {
  return async dispatch => {
    dispatch(postPhotoVignetteRequest());
    try {
      const data = await photoVignetteService.post(categoryId, json);
      if (data && data[0]) {
        dispatch(setPhotoVignetteData(channelId, data[0].urlImage));
        dispatch(setPhotoVignetteFilename(channelId, data[0].fileName));
      }
    } catch(err) {
      dispatch(actionsModalError.openModalError('Intente nuevamente'));
      dispatch(postPhotoVignetteFailure());
    }
  }
};
